import industryAttributesReducer from './industry-attributes-reducer'
import countryReducer from './country-reducer'

const reducers = {
  industryAttributes: industryAttributesReducer,
  countries: countryReducer,
}

export default reducers